import { render, staticRenderFns } from "./OnBoardingLayout.vue?vue&type=template&id=82ebf218&"
import script from "./OnBoardingLayout.vue?vue&type=script&lang=ts&"
export * from "./OnBoardingLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports